import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";
import { UpdateBoardRequestBody, UpdateBoardResponse } from "../../api/board";

export type TApiPutBoard = {
  result?: UpdateBoardResponse;
};

export const putBoard = async (
     body: UpdateBoardRequestBody
): Promise<TApiResult & TApiPutBoard> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  return await client()
    .board.put({
      body,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "putBoard");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
